import request from "@/utils/request";

export function getDetail(data) {
	return request({
		url: '/app/news/detail',
		method: 'post',
		data
	})
}

export function getDetailByCode(code) {
	return request({
		url: `/app/public/news/detail?code=${code}`,
		method: 'get',
	})
}

export function getList(data) {
	return request({
		url: '/app/news/list',
		method: 'post',
		data
	})
}

export function markRead(data) {
	return request({
		url: '/app/news/read',
		method: 'post',
		data
	})
}
